import React from 'react';
import createCategoryRoute from '../utils/category-page';

import CategoryPage from '../components/common/CategoryPage';

import { selectEpoch } from '../selectors/epoch';
import { loadEpoch } from '../actions/epoch';

const route = createCategoryRoute({
  categorySelector: selectEpoch,
  categoryLoader: loadEpoch,
  facetType: 'epochs',
  contextFacet: 'Epoch',
  baseRoute: '/periods',
});

const Epoch = ({ ...props }) => {
  return <CategoryPage {...props} />;
};

export default route(Epoch);
